import {
  Component,
  Input,
  EventEmitter,
  ViewChildren,
  QueryList,
  AfterViewInit
} from '@angular/core';

import Product from 'src/app/model/product/product';
import { Project } from 'src/app/model/project/project';
import { CustomerProjectInfoOneComponent } from '../customer-project-info-one/customer-project-info-one.component';
import PMSColor from 'src/app/model/company/pmscolor';
import { Subject } from 'rxjs';
import Company from 'src/app/model/company/company';

@Component({
  selector: 'customer-project-info-all',
  templateUrl: './customer-project-info-all.component.html',
  styleUrls: ['./customer-project-info-all.component.scss']
})
export class CustomerProjectInfoAllComponent implements AfterViewInit {
  @Input()
  public inputProject: Project;
  @Input()
  public inputProduct: Product;
  @Input()
  public involvedCompanies: Company[];
  @Input()
  public updateEmitter: EventEmitter<any>;
  @Input()
  public pmsColorAdded: Subject<PMSColor>;

  @ViewChildren(CustomerProjectInfoOneComponent)
  viewChildren: QueryList<CustomerProjectInfoOneComponent>;

  ngAfterViewInit() {
    this.viewChildren.forEach(vc => {
      vc.update.subscribe(() => {
        this.customerInfoChanged();
      });
    });
  }

  customerInfoChanged() {
    this.inputProduct.productCompanyPMSColors = [];
    this.viewChildren.forEach(vc => {
      this.inputProduct.productCompanyPMSColors = this.inputProduct.productCompanyPMSColors.concat(
        vc.pcps
      );
    });
    this.updateEmitter.emit();
  }
}
